export default (message, freeArea) => value => (value <= freeArea ? undefined : message);
